// 模組04 營運資訊(IP/專案/合約/廠商)+ 模組05 軟體 — mock 種子(空殼頁資料層)
// Sprint 2 完整 CRUD 前的殼:欄位對準需求確認書,API 到位時替換 dck_helper 即可,UI 不動。
export const ips = [
  { id: 1, ip: "10.10.32.15", purpose: "核心服務主機", deviceCode: "SRV-A01-001", status: "使用中", approvalStatus: "approved" },
  { id: 2, ip: "10.10.32.16", purpose: "資料庫主機", deviceCode: "SRV-A01-002", status: "使用中", approvalStatus: "approved" },
  { id: 3, ip: "10.10.33.20", purpose: "備援", deviceCode: "SRV-B02-001", status: "保留", approvalStatus: "approved" },
];

export const projects = [
  { id: 1, name: "核心網路汰換 2026", owner: "林承翰（資訊處）", startDate: "2026-01-15", endDate: "2026-11-30", status: "進行中", approvalStatus: "approved" },
  { id: 2, name: "機房整併專案", owner: "張家豪（維運部）", startDate: "2026-03-01", endDate: "2026-08-15", status: "進行中", approvalStatus: "approved" },
];

export const contracts = [
  { id: 1, name: "機房維運服務合約 2026", vendorName: "創唯科技", endDate: "2026-10-15", amount: 1200000, status: "生效中", approvalStatus: "approved" },
  { id: 2, name: "網路設備保固合約", vendorName: "神通資訊", endDate: "2027-03-31", amount: 680000, status: "生效中", approvalStatus: "approved" },
];

export const vendors = [
  { id: 1, name: "創唯科技", type: "系統整合", rating: "A", contact: "王經理", phone: "02-2345-6789", approvalStatus: "approved" },
  { id: 2, name: "神通資訊", type: "硬體維修", rating: "B", contact: "李工程師", phone: "02-8765-4321", approvalStatus: "approved" },
];

/**
 * 軟體資訊（DCK-05 軟體，Figma v2 `2128:25038`）。
 *
 * 欄位對齊 v2 列表:資產編號/Host Name・廠牌/型號・版號・部署設備數・
 * EOS・EOL・CVE・KEV・管理者。
 *
 * `deployedHardwareIds` 指向 db/assets.js 的硬體 —— 機房/機櫃/U 位由硬體那邊推導,
 * 不在這裡再存一份(展開列要顯示的位置資訊是同一個來源,重複存一定會漂移)。
 * `starred` 是列表上的★特別關注,與硬體同一個語意 —— 新增/編輯表單的「關鍵業務」
 * 寫的就是這個欄位(設計稿說「啟用後…加入星號」,兩個欄位遲早會對不起來)。
 *
 * 新增/編輯表單(Figma v2 `2128:26586`)另外用到這些欄位:
 *   基本:bizType・propertyNo・managerId・assetType・serialNo・env・remark
 *   資安:cveHits[](每日比對命中的 CVE,唯讀)・scan / pentest(弱掃、滲透測試)
 *   IP資訊分頁:ip・parentIp・ports[]
 */
export const software = [
  {
    id: 1, code: "SW-0001", name: "VMware vSphere",
    brand: "VMware", model: "vSphere Enterprise Plus", version: "8.0 U2",
    deployedHardwareIds: [1, 4],
    eos: "2027-10-31", eol: "2029-10-31",
    cveLevel: null, cveDate: null, kevLevel: null, kevDate: null,
    cveHits: [],
    manager: "林承翰", managerId: 1, starred: false,
    bizType: "一類業務", assetType: "系統相關", env: "營運",
    propertyNo: "PRP-2024-0101", serialNo: "VS8-0001-AAAA-1111",
    remark: "虛擬化平台,全機房共用。",
    scan: { date: "", nextDate: "", rows: [] },
    pentest: { date: "", nextDate: "", rows: [] },
    ip: "10.10.32.15", parentIp: "10.10.32.1", ports: ["443/tcp", "902/tcp"],
    status: "使用中", approvalStatus: "approved",
  },
  {
    id: 2, code: "SW-0012", name: "Windows Server",
    brand: "Microsoft", model: "Windows Server Datacenter", version: "2019 Std",
    deployedHardwareIds: [2, 5, 6],
    // 四種風險都踩到的那一筆 —— 列表的風險欄與快速篩選要有東西可篩
    eos: "2026-06-30", eol: "2026-12-31",
    cveLevel: "嚴重", cveDate: "2026-06-30", kevLevel: "高", kevDate: "2026-12-31",
    // 命中清單(設計稿 `2198:58231` 的兩列範例):每日同步後依版本比對產生,唯讀
    cveHits: [
      { cve: "CVE-2026-11884", published: "2026/05/14", kevLevel: null, kevDate: null, version: "2.10.5" },
      { cve: "CVE-2026-10233", published: "2026/03/02", kevLevel: "高", kevDate: "2026/06/10", version: "2.10.5" },
    ],
    manager: "林承翰", managerId: 1, starred: true,
    bizType: "一類業務", assetType: "系統相關", env: "營運",
    propertyNo: "PRP-2024-0112", serialNo: "WS19-DC-2222-3333",
    remark: "",
    // 弱掃／滲透測試各留已修補/未修補的列,修補狀態與備註兩欄才有東西可操作
    scan: {
      date: "2026-05-14", nextDate: "2026-11-14", rows: [
        { version: "2019 Std", patched: "Y", risk: "中", fileDate: "2025/12/3", note: "已套用 5 月累積更新" },
        { version: "2016 Std", patched: "N", risk: "高", fileDate: "2025/12/3", note: "" },
      ],
    },
    pentest: {
      date: "2026-04-02", nextDate: "2026-10-02", rows: [
        { version: "2019 Std", patched: "N", risk: "低", fileDate: "2025/12/3", note: "" },
      ],
    },
    ip: "10.10.32.16", parentIp: "10.10.32.1", ports: ["3389/tcp"],
    status: "使用中", approvalStatus: "approved",
  },
  {
    id: 3, code: "SW-0023", name: "Red Hat Enterprise Linux",
    brand: "Red Hat", model: "RHEL Server", version: "9.4",
    deployedHardwareIds: [3],
    eos: "2030-06-30", eol: "2030-06-30",
    cveLevel: null, cveDate: null, kevLevel: null, kevDate: null,
    cveHits: [],
    manager: "張家豪", managerId: 2, starred: false,
    bizType: "二類業務", assetType: "系統相關", env: "測試",
    propertyNo: "", serialNo: "RHEL94-4444-5555",
    remark: "",
    scan: { date: "", nextDate: "", rows: [] },
    pentest: { date: "", nextDate: "", rows: [] },
    ip: "10.10.33.20", parentIp: "", ports: [],
    status: "使用中", approvalStatus: "approved",
  },
  {
    // 還沒部署到任何設備 —— 列表的「部署設備數 0 台」與展開後的空狀態要有樣本
    id: 4, code: "SW-0031", name: "Oracle Database",
    brand: "Oracle", model: "Database Enterprise", version: "19c",
    deployedHardwareIds: [],
    eos: "", eol: "",
    cveLevel: null, cveDate: null, kevLevel: null, kevDate: null,
    cveHits: [],
    manager: "林承翰", managerId: 1, starred: false,
    bizType: "三類業務", assetType: "軟體相關", env: "開發",
    propertyNo: "", serialNo: "ORA19C-6666-7777",
    remark: "採購完成,尚未安裝。",
    scan: { date: "", nextDate: "", rows: [] },
    pentest: { date: "", nextDate: "", rows: [] },
    ip: "10.10.34.10", parentIp: "", ports: [],
    status: "閒置", approvalStatus: "approved",
  },
  {
    // 審核中 —— 列表要顯示「審核中｜單號」且操作欄的編輯/刪除要停用
    id: 5, code: "SW-0044", name: "Nginx",
    brand: "F5", model: "NGINX Plus", version: "R32",
    deployedHardwareIds: [1],
    eos: "", eol: "",
    cveLevel: null, cveDate: null, kevLevel: null, kevDate: null,
    cveHits: [],
    manager: "林承翰", managerId: 1, starred: false,
    bizType: "一類業務", assetType: "系統相關", env: "DMZ區域",
    propertyNo: "", serialNo: "NGXP-R32-8888",
    remark: "",
    scan: { date: "", nextDate: "", rows: [] },
    pentest: { date: "", nextDate: "", rows: [] },
    ip: "10.10.35.5", parentIp: "", ports: ["80/tcp", "443/tcp"],
    status: "使用中",
    docNo: "SW-2026-0044", approvalStatus: "pending",
  },
];
